export default function getSettings() {
  if (typeof global.OFS_SETTINGS === 'undefined') {
    throw new Error('JS settings not defined');
  }

  return global.OFS_SETTINGS;
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/getSettings.js
 **/